<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline" v-if="is_assign">Assign Phone Numbers</v-card-title>
    <v-card-title class="headline" v-if="!is_assign">Remove Phone Numbers from Organization</v-card-title>

    <v-card-text>
       <v-chip
        v-for="(endpoint, index) in endpoints"
        :key="index"
        close
        style="margin-right: 15px; margin-bottom: 15px;"
        @click:close="removeEndpoint(endpoint)"
       >
        {{prettyPrint(endpoint)}}
       </v-chip>

       <m-autocomplete-organization
            label="Assign to Organization"
            v-model="organization_id"
            v-if="is_assign"
       />
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="is_assign && organization_id == null"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            organization_id: null,
            endpoints: [],
            is_assign: true,
        }
    },

    methods: {
        showDialog(endpoints, is_assign) 
        {
            this.dialog = true;
            this.endpoints = endpoints;
            this.is_assign = is_assign;
            this.organization_id = null;
        },
        
        onOk()
        {
           this.dialog = false;

           this.$rc.showSpinner();

           let params = {
               'endpoints' : this.endpoints,
               'organization_id' : this.organization_id,
           };

           this.$rc.assignRedChirpPhoneNumbers(
               params,

               () => {
                   this.$rc.hideSpinner();
                   this.$rc.snackbar(this.endpoints.length+' phone number(s) assigned', 2000);
                   this.$emit('ok');
               },

               () => {
                   this.$rc.hideSpinner();
                   this.$rc.alert('Error', 'Unnable to assign phone numbers');
               }
           )
        },

        prettyPrint(endpoint)
        {
            return E164.prettyPrintUsPhoneNumber(endpoint)
        },

        removeEndpoint(endpoint)
        {
            let ret = [];

            for ( let i = 0; i < this.endpoints.length; i++ )
            {
                if ( this.endpoints[i] == endpoint ) continue;
                ret.push(this.endpoints[i]);
            }

            this.endpoints = ret;

            if ( ret.length == 0 )
                this.dialog = false; // same as cancelling...
        },
    },
}
</script>

<style lang="scss" scoped>

</style>